(function($){
    if($('.jet-smart-filters-range').length > 0){
        setTimeout(function(){
            $('.jet-smart-filters-range').slideDown(300);
        }, 1000)
    }
})(jQuery)